<template>
  <div>
    <v-dialog
      v-model="deleteDialog.open"
      max-width="290px"
    >
      <v-card>
        <v-card-title>
          Potrdite izbris priponke
        </v-card-title>
        <v-card-text>
          {{ deleteDialog.attachment.original_name }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            variant="text"
            @click="deleteDialog.open = false"
          >
            Prekliči
          </v-btn>
          <v-btn
            color="error"
            @click="deleteAttachment"
          >
            Izbriši
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-file-upload
      v-if="canUpload"
      ref="attachment"
      v-model="attachment"
      data-cy="attachment-file-input"
      density="compact"
      clearable
      show-size
      :rules="attachmentRules"
      :disabled="!canUpload"
      required
    />

    <v-btn
      v-if="canUpload"
      color="primary"
      variant="outlined"
      data-cy="upload-attachment"
      :loading="uploadInProgress"
      :disabled="!canUpload"
      @click="uploadAttachment"
    >
      Pripni
    </v-btn>

    <v-list v-if="attachments">
      <v-list-item
        v-for="attachment in attachments"
        :key="attachment.attachment_id"
        data-cy="attachment-row"
        :title="attachment.original_name"
        :href="attachment.download_url"
      >
        <template #append>
          <v-btn
            v-if="canUpload"
            icon
            color="error"
            variant="text"
            aria-label="Izbriši priponko"
            @click.prevent="showConfirmationDialog(attachment)"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'JournalAttachments',
  props: ['projectId', 'date', 'canUpload', 'attachments'],
  data: () => ({
    uploadInProgress: false,
    attachment: null,
    attachmentRules: [
      v => !!v || 'Priponka je obvezna',
    ],

    deleteDialog: {
      open: false,
      attachment: {
        original_name: '',
        attachment_id: '',
      },
    }
  }),
  methods: {
    async uploadAttachment() {
      if ((await this.$refs.attachment.validate()).length === 0) {
        this.uploadInProgress = true;

        const projectId  = this.projectId;
        const date       = this.date;
        const attachment = this.attachment;

        await this.$store.dispatch('uploadSiteLogAttachment', { projectId, date, attachment });

        this.uploadInProgress = false;
        this.attachment = null;
      }
    },
    showConfirmationDialog(attachment) {
      this.deleteDialog.attachment = attachment;
      this.deleteDialog.open = true;
    },
    async deleteAttachment() {
      const projectId    = this.projectId;
      const date         = this.date;
      const attachmentId = this.deleteDialog.attachment.attachment_id;

      await this.$store.dispatch('deleteSiteLogAttachment', { projectId, date, attachmentId });
      this.deleteDialog.open = false;
    }
  },
}
</script>
